import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {
    awardListChannel = new Subject();
    detailChannel = new Subject();
    reloadChannel = new Subject();
    exportChannel = new Subject();
    repository = new IndexRepository()

    constructor() {
        this.awardListChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.reloadChannel.next({status: apiResponse.INITIAL})
        this.exportChannel.next({status: apiResponse.INITIAL})
    }

    fetchAwardList = async (query) => {
        try {
            this.awardListChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchAwardList(query).then((result) => {
                this.awardListChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.awardListChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubcribed')
        }
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })   
        } catch (error) {
            console.log('rxjs', 'Channel Unsubcribed')
        }
    }

    fetchReload = async (query) => {
        try {
            this.reloadChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchReload(query).then((result) => {
                this.reloadChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.reloadChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }


    fetchExport = async (query) => {
        try {
            this.exportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchExport(query).then((result) => {
                this.exportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.exportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }


}

export default IndexBloc